// (function () {
//     'use strict';

//     angular.module("imApp").factory("acRemLtrService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 3092,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 3093,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
